
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/[slug]",
      function () {
        return require("private-next-pages/industry/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industry/[slug]"])
      });
    }
  